// SET_TEXT_FILTER
export const setTextFilter = (text = '') => ({
    type: 'SET_TEXT_FILTER',
    text
})


// WEBPACK FOOTER //
// ./src/actions/filters.js